import {
  ODataHeader,
  ODataString,
  ODataDecimal,
  ODataDate,
} from "pbas-vue-components";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});

const ClaimSubmissionsHeaders = [
    new ODataHeader({
        title: "components.claims_history.header.submission_id",
        type: new ODataString("ClaimSubmissionId"),
        sortable: true,
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
      }),  
  new ODataHeader({
    title: "components.claims_history.header.submission_id",
    type: new ODataString("Submissionid"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.claim_submissions.certificate_number",
    type: new ODataString("StudentId"),
    sortable: true,
    visible: true,
    searchable: true,    
  }),
  new ODataHeader({
    title: "headers.claim_submissions.amount_requested",
    type: new ODataDecimal("ClaimAmountTotal", {
      getString: (item) => {
        const value = item.ClaimAmountTotal;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "headers.claim_submissions.date_submitted",
    type: new ODataDate("CreatedOn"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.plan",
    type: new ODataString("PlanNumber"),
    sortable: true,
    visible: true,
    searchable: true,    
  }),
  new ODataHeader({
    title: "globals.lastname",
    type: new ODataString("LastName"),
    sortable: true,
    visible: true,
    searchable: true,    
  }),
  new ODataHeader({
    title: "globals.firstname",
    type: new ODataString("FirstName"),
    sortable: true,
    visible: true,
    searchable: true,    
  }),
];
export default ClaimSubmissionsHeaders;
